<mat-card class="pl-2 pr-2">
  <div class="d-flex bd-highlight align-items-center">
    <div class="w-100 bd-highlight text-truncate">
      <ng-content select="[content]"></ng-content>
    </div>
    <div class="flex-shrink-1 bd-highlight">
      <button mat-icon-button color="primary">
        <mat-icon color="primary">chevron_right</mat-icon>
      </button>
    </div>
  </div>
</mat-card>
